'use client';

import { c as _c } from "react/compiler-runtime";
import { NexperienceAvailableAndAlternativeDatesDocument } from '@data-access/lib/gql/experience/documents';
import { useGraphQL } from '@data-access/lib/graphql-query';
import { keepPreviousData } from '@tanstack/react-query';
import { useExperienceFilterContext } from '../_components/app-experience-filter-provider';
import { EXPERIENCE_AVAILABILITY_STALE_TIME, getExperienceTimeslotsPreviewVariables } from '../_lib/experience-availability-query';
import { mapDatesToEdpTimeslots } from '../_lib/experience-booking-utils';
import { displayedDateRange } from '../_lib/experience-date-range';
import { useAppExperienceDayPrices } from './use-app-experience-day-prices';
import { useExperiencePreviewToken } from './use-experience-preview-token';
export function useAppExperienceTimeslotsPreview(t0) {
  const $ = _c(12);
  const enabled = t0 === undefined ? true : t0;
  const {
    experience,
    baseVariants,
    filter: experienceFilter
  } = useExperienceFilterContext();
  const previewToken = useExperiencePreviewToken();
  let t1;
  if ($[0] !== experience.publicId || $[1] !== experienceFilter || $[2] !== previewToken) {
    t1 = getExperienceTimeslotsPreviewVariables({
      publicId: experience.publicId,
      previewToken,
      filter: experienceFilter
    });
    $[0] = experience.publicId;
    $[1] = experienceFilter;
    $[2] = previewToken;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const variables = t1;
  let t2;
  if ($[4] !== enabled) {
    t2 = {
      select: _temp,
      enabled,
      placeholderData: keepPreviousData,
      staleTime: EXPERIENCE_AVAILABILITY_STALE_TIME
    };
    $[4] = enabled;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data,
    isLoading,
    isPlaceholderData,
    isError,
    refetch,
    isFetching,
    errorUpdatedAt,
    dataUpdatedAt
  } = useGraphQL(NexperienceAvailableAndAlternativeDatesDocument, variables, t2);
  let t3;
  if ($[6] !== data?.dates) {
    t3 = data?.dates ?? [];
    $[6] = data?.dates;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const dates = t3;
  let t4;
  if ($[8] !== data?.alternativeDates) {
    t4 = data?.alternativeDates ?? [];
    $[8] = data?.alternativeDates;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const alternativeDates = t4;
  const shownDates = [...dates, ...alternativeDates];
  const range = enabled ? displayedDateRange(shownDates) : null;
  const prices = useAppExperienceDayPrices(experience.id, range?.from, range?.to);
  let t5;
  if ($[10] !== experienceFilter.selectedOptions) {
    t5 = option => Object.hasOwn(experienceFilter.selectedOptions ?? {}, option.id);
    $[10] = experienceFilter.selectedOptions;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const options = baseVariants.flatMap(_temp2).filter(t5);
  const allTimeslots = mapDatesToEdpTimeslots(shownDates, options, experienceFilter.selectedOptions, prices.dayPrices);
  const timeslots = allTimeslots.slice(0, 5);
  return {
    alternativeDates,
    dates,
    shownDates,
    timeslots,
    allTimeslots,
    prices,
    isLoading,
    isPlaceholderData,
    isError: isError || isFetching && errorUpdatedAt > dataUpdatedAt,
    isFetching,
    refetch
  };
}
function _temp2(variant) {
  return variant.options;
}
function _temp(response) {
  return {
    dates: response.nexperienceAvailableDates.dates,
    alternativeDates: response.nexperienceAvailableDates.alternativeDates
  };
}